import React from "react";
import { cn } from "@/lib/utils";

/**
 * Controlle-merket: en presis ring som leses som «C», med et kontrollpunkt i åpningen
 * og en diskré hake inni. Tegnes med currentColor slik at farge styres via CSS.
 * Omkrets ved r=22 ≈ 138,2. Åpningen (≈ 80°) er sentrert mot høyre.
 */
export const ControlMark = ({ size = 32, className, withTick = true, title }) => (
  <svg
    viewBox="0 0 64 64"
    width={size}
    height={size}
    fill="none"
    role={title ? "img" : undefined}
    aria-hidden={title ? undefined : true}
    aria-label={title}
    className={cn("shrink-0", className)}
  >
    <circle cx="32" cy="32" r="22" stroke="currentColor" strokeWidth="6" strokeLinecap="round" strokeDasharray="107 31.2" strokeDashoffset="-15.6" />
    {withTick ? <path d="M22.5 32.5 L29 39 L41.5 25.5" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" /> : null}
    <circle cx="54" cy="32" r="4.6" fill="currentColor" />
  </svg>
);

/** Horisontal lockup: merke + ordmerke. `tone` = "default" (teal merke, mørk tekst) | "inverse" (alt hvitt). */
export const ControlLogo = ({ size = 28, tagline, className, tone = "default", to }) => {
  const inner = (
    <>
      <span className={cn("inline-flex items-center justify-center rounded-lg", tone === "inverse" ? "text-white" : "text-primary")} style={{ width: size + 12, height: size + 12 }}>
        <ControlMark size={size} />
      </span>
      <span className="leading-tight">
        <span className={cn("block font-heading font-bold tracking-[-0.02em]", tone === "inverse" ? "text-white" : "text-foreground")} style={{ fontSize: Math.round(size * 0.72) }}>Controlle</span>
        {tagline ? <span className={cn("block text-[11px]", tone === "inverse" ? "text-white/75" : "text-muted-foreground")}>{tagline}</span> : null}
      </span>
    </>
  );
  return <span className={cn("inline-flex items-center gap-1.5", className)}>{inner}</span>;
};
